import React from 'react';
import classNames from 'classnames';
import { RSFormLabel } from 'reactsymbols-kit';
import type { IFSM } from '../../stores/model/metamodel/fsm';

export interface FSMSelectProps {
  /** The list of possible FSMs. */
  fsms: IFSM[];
  /** The ids of the selected FSMs. */
  selected: string[];
  /** Change handler — receives the new list of selected ids. */
  onChange: (selected: string[]) => void;
  /** Show a label with 'Choose FSMs'? Default: true. */
  showHelp?: boolean;
  /** Maximum number of FSMs that can be selected. */
  max?: number;
}

/**
 * A select component for FSMs. Used a.o. to select the FSM to use for
 * calculating a new FSM from existing FSMs.
 */
const FSMSelect = ({ fsms, selected, onChange, showHelp = true, max }: FSMSelectProps) => {
  const toggleFSM = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter(s => s !== id));
    } else {
      if (max == null || selected.length < max) {
        onChange(selected.concat([id]));
      }
    }
  };

  return (
    <div>
      {showHelp && <RSFormLabel>Choose FSMs</RSFormLabel>}
      {fsms.map(fsm => (
        <div
          key={fsm.id}
          className={classNames('cursor-pointer p-2.5', {
            'bg-primary text-white': selected.includes(fsm.id),
          })}
          onClick={() => toggleFSM(fsm.id)}
        >
          {fsm.name}
        </div>
      ))}
    </div>
  );
};

export default FSMSelect;
